module.exports = __webpack_public_path__ + "img/ring_g_skip_null_1@2x.d407a496.png";